module.exports = __webpack_public_path__ + "img/partners6.1d84b160.jpg";